import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchProduct, postProduct } from '../services/customizerAPI';

export const getProductDetail = createAsyncThunk(
  'GET_PRODUCT_DETAIL_ACTION_TYPES',
  async ({ url, type = 1 }: { url: string; type: number }) => {
    const response = await fetchProduct(url, type);
    return response?.data;
  }
);

export const createProduct = createAsyncThunk('CREATE_PRODUCT_ACTION_TYPES', async ({ data }: { data: any }) => {
  const response = await postProduct(data);
  return response?.data;
});
